import {Button, ButtonSalvar, Col, Label, ValueCard} from "../../../painelDePagamentos/components/filter/styles";
import React, {useState} from "react";
import {Row} from "antd";
import {Formik, Form} from "formik";
import {Container} from "../../../painelDeDepositos/styles";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import Select from "antd/lib/select";
import {IFormFilterProps, EfeitoContratoFilterProps} from "../../types";
import useGetMe from "../../../../../hooks/useCurrentUser";


export const FormFilter: React.FC<IFormFilterProps> = ({onFormSubmit, loading}) => {
  const [localState, setLocalState] = useState<EfeitoContratoFilterProps>({
    settlementDate: '',
    cnpj: '',
    status: '',
    ispb: '',
  });

  const user = useGetMe();

  const initialValues: EfeitoContratoFilterProps = {
    settlementDate: '',
    cnpj: '',
    status: '',
    ispb: '',
  };

  return (
    <Container style={{padding: '0px'}}>
      <LoadingOverlay show={loading} relative/>

      <Formik<EfeitoContratoFilterProps>
        initialValues={initialValues}
        onSubmit={onFormSubmit}
      >
        {({setFieldValue}) => (
          <Form>
            <Row gutter={16}>
              <Col xs={{flex: '100%'}}
                   sm={{flex: '50%'}}
                   md={{flex: '40%'}}
                   lg={{flex: '20%'}}
                   xl={{flex: '10%'}}>
                <input type="date" name="settlementDate"
                       onChange={(e) => {
                         setLocalState({...localState, settlementDate: e.target.value});
                         setFieldValue('settlementDate', e.target.value);
                       }} placeholder="Data Liquidação" step="1"/>
              </Col>
              {user.userType === 3 && (
                <Col xs={{flex: '100%'}}
                     sm={{flex: '50%'}}
                     md={{flex: '40%'}}
                     lg={{flex: '20%'}}
                     xl={{flex: '10%'}}>
                  <input type="text" name="cnpj" placeholder="CPF/CNPJ do cliente"
                         onChange={(e) => {
                           setLocalState({...localState, cnpj: e.target.value});
                           setFieldValue('cnpj', e.target.value);
                         }}/>
                </Col>
              )}

              <Col xs={{flex: '100%'}}
                   sm={{flex: '50%'}}
                   md={{flex: '40%'}}
                   lg={{flex: '20%'}}
                   xl={{flex: '10%'}}>
                <input type="text" name="ispb" placeholder="ISPB Solicitante" onChange={(e) => {
                  setLocalState({...localState, ispb: e.target.value});
                  setFieldValue('ispb', e.target.value);
                }}/>
              </Col>
              <Col xs={{flex: '100%'}}
                   sm={{flex: '50%'}}
                   md={{flex: '40%'}}
                   lg={{flex: '20%'}}
                   xl={{flex: '10%'}}>
                <Select
                  defaultValue={''}
                  style={{width: '100%'}}
                  onChange={(value) => {
                    setLocalState({...localState, status: value});
                    setFieldValue('status', value);
                  }}
                  options={[
                    {
                      value: '',
                      label: 'Status do Efeito',
                    },
                    {
                      value: "p",
                      label: 'Pendente',
                    },
                  ]}
                />
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" style={{background: '#fbb651'}}>
                  Consultar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
